import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { MetricsTestimonialsSection } from './components/MetricsTestimonialsSection';
import { ExtendedTestimonialsSection } from './components/ExtendedTestimonialsSection';
import { PainSection } from './components/PainSection';
import { TransitionHookSection } from './components/TransitionHookSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { ProductShowcaseSection } from './components/ProductShowcaseSection';
import { ModulesSection } from './components/ModulesSection';
import { VipModuleSection } from './components/VipModuleSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencySection } from './components/UrgencySection';
import { PriceSection } from './components/PriceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { FooterSection } from './components/FooterSection';
const META_PIXEL_ID = '929826529816985';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/wD6XHHXqEzi2b4vbyPnFv3/hf_20260528_015615_d7bdc0e4-f184-4423-868f-2fe77bd4c3a9-removebg-preview.png';
export function App() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700&family=Fraunces:opsz,wght@9..144,700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);
  return <div className="font-sans text-white bg-familia-bg min-h-screen selection:bg-familia-cyan selection:text-familia-bg" data-id="element-0">
      <HeroSection data-id="element-1" />
      <MetricsTestimonialsSection data-id="element-2" />
      <ExtendedTestimonialsSection isInitial={true} data-id="element-3" />
      <PainSection data-id="element-4" />
      <TransitionHookSection data-id="element-5" />
      <ProductIntroSection data-id="element-6" />
      <ProductShowcaseSection data-id="element-7" />
      <ModulesSection data-id="element-8" />
      <VipModuleSection data-id="element-9" />
      <BonusesSection data-id="element-10" />
      <UrgencySection data-id="element-11" />
      <PriceSection data-id="element-12" />
      <ExtendedTestimonialsSection data-id="element-13" />
      <GuaranteeSection data-id="element-14" />
      <FaqSection data-id="element-15" />
      <ComparisonSection data-id="element-16" />
      <FinalCtaSection data-id="element-17" />
      <FooterSection data-id="element-18" />
    </div>;
}